import { render, staticRenderFns } from "./ParrillaComponent.vue?vue&type=template&id=fd764846&scoped=true&lang=es"
import script from "./ParrillaComponent.vue?vue&type=script&lang=js"
export * from "./ParrillaComponent.vue?vue&type=script&lang=js"
import style0 from "./ParrillaComponent.vue?vue&type=style&index=0&id=fd764846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd764846",
  null
  
)

export default component.exports